<template>
<!-- <Layout> -->

<!-- component_b2bQuickOrderAlert -->
<!-- Can probably put this into builder? -->
<div>
    <div class="b2b-quick-order__notification">
        <div class="notification notification-alert">
            <BellIcon alt="Notification" />
            <!-- <Cms
                model="quick-order-header-message"
                v-show="false"
                is-data
                driver="builder"
                v-model="headerMsgs"
                id="cms_component"
            /> -->
            <p class="paragraph-details"> {{ headerMsg }}</p>
         </div>
    </div>

    <!-- BODY -->
    <section class="b2b-quick-order">
        <div class="b2b-quick-order__title-wrapper">
            <Link v-show="isAddingItems" :href="route('index.quickOrdering')" class="title-s csv-upload__backCta">Back to Quick Order</Link>
			<h1 class="headline-l">{{title}}</h1>
		</div>

        <!-- component_b2bQuickOrderList -->
        <div class="b2b-quick-order__list-wrapper">
            <custom-select ref="currentListSelector" v-model="currentList" id="quick-order" :options="newListMap" :allowBackendSearch="true" :onBackendSearch="handleSearch" custom-label no-borders>
                <template #label="{ selected }">
                    <p v-if="selected.record" id="quick-order-label" class="label">Last Modified {{ formatDisplayDate(selected.record.updated_at) }} | Qty: {{selected.record.total_quantity}}</p>
                    <p class="selected-option" style="width: unset; white-space: nowrap;">{{selected.value}}</p>
                </template>
            </custom-select>
            <!-- <div class="dropdown no-borders- select">
                <div class="select-wrapper">
                    <select name="current_list" id="current_list" :value="currentList.value" @change="setCurrentList($event)">
                        <option v-for="(list, i) in listsMap" :key="i" :value="list.value" :selected="list.value == currentList.value">
                            {{ list.label }}
                        </option>
                    </select>
                    <label class="paragraph-caption">
                        Last Modified {{ formatDisplayDate(currentList.record.updated_at) }} | Qty: {{ currentList.record.total_quantity }}
                    </label>
                </div>

            </div> -->
            <div class="list-config">
                <a class="paragraph-default" href="#" @click="openRenameList()">Rename List</a> 
                <span class="divider">|</span>
                <a class="paragraph-default" href="#" @click="openCreateList()">Start New List</a>
            </div>
        </div>

        <div class="input-search-container">
            <div v-show="!isAddingItems" class="search-container">
                <PrimeInputText
                    v-model="inputValue" 
                    id="search_input" 
                    ref="search_input" 
                    type="search" 
                    placeholder="Search item name, number, or UPC" 
                    class="paragraph-details quick-ordering-search-input" 
                    aria-label="Search item name, number, or UPC" 
                    @keydown.enter="search()"
                />
                <a href="#" class="search-button" aria-label="Search" @click="search()">
                    <SearchIcon alt="Magnifying glass" />
                </a>
                <Link :href="route('csv-upload')" class="upload-csv paragraph-default" aria-label="Upload CSV">Upload CSV</Link>
            </div>
            <div class="summary">
                <div class="summary-text">
                    <p class="title-s">Styles</p>
                    <p class="paragraph-default">{{ currentListTotals.styles }}</p>
                </div>
                <div class="summary-text">
                    <p class="title-s">SKUs</p>
                    <p class="paragraph-default">{{ currentListTotals.skus }}</p>
                </div>
                <div class="summary-text">
                    <p class="title-s">Qty</p>
                    <p class="paragraph-default">{{ currentListTotals.quantity }}</p>
                </div>
                <div class="summary-text">
                    <p class="title-s text-right">Total</p>
                    <p class="paragraph-default">{{ canSeePricing ? ('$' + formatPrice(currentListTotals.price)) : '--' }}</p>
                </div>
            </div>
            <RothcoCta v-if="canCheckout && !isAddingItems && canPlaceOrders" class="primary" aria-label="Proceed to Checkout" id="checkout_btn" :href="route('checkout.express')">
                Checkout
            </RothcoCta>
            <RothcoCta v-else-if="isAddingItems && +currentListTotals.skus > 0" class="primary" aria-label="Add to Cart" @click.prevent="addItemsTable?.add()" id="addtolist_btn">
                Add to Cart
            </RothcoCta>
        </div>

        <div v-if="!isAddingItems">
            <quick-ordering-search-page
                id="viewListTable"
                ref="viewListTable"
                :key="current_list.list_id"
                v-model:allTotals="currentListTotals"
                :products="props.currentListItems"
                :list-id="current_list.list_id"
                :adding-items="false"
            />
        </div>
        <div v-else-if="isAddingItems && (isStyle || isUpc)">
            <quick-ordering-search-page
                id="addItemsTable"
                ref="addItemsTable"
                key="addItemsTable"
                v-model:allTotals="currentListTotals"
                :products="isStyle || isUpc ? props.searchResults : []"
                :list-id="current_list.list_id"
                :adding-items="true"
            />
        </div>
        <div v-else>
            <rothco-table
                :pt="{
                    root: 'b2b-quick-order__table-content'
                }"
                :visible-fields="visibleFields"
                :content="keywordSearchResults"
                v-model:selected-row="selectedRow"
                :useVirtualRows="true"
                focusable
            >
                <template
                    v-for="(item, index) of keywordSearchResults"
                    :key="'image_' + index"
                    v-slot:[`image_${index}`]="slotProps"
                >
                    <img
                        loading="lazy"
                        v-if="item.data.image"
                        :src="item.data.image"
                        alt=""
                        style="height: 150px; width: auto; object-fit: contain"
                    />
                </template>
                <template
                    v-for="(item, index) of keywordSearchResults"
                    :key="'item_' + index"
                    v-slot:[`item_name_${index}`]="slotProps"
                >
                    <a
                        :href="
                            item.data.seo_name ? route('productDetail.show', [item.data.seo_name]) : '/'
                        "
                        target="_blank"
                    >
                        {{ item.data.item_name }}
                    </a>
                </template>
                <template
                    v-for="(item, index) of keywordSearchResults"
                    :key="'short_desc_' + index"
                    v-slot:[`item_short_desc_${index}`]="slotProps"
                >
                    <p class="text-wrap">{{ item.data.item_short_desc }}</p>
                </template>
            </rothco-table>
        </div>

        <div class="b2b-quick-order__information">
            <div class="b2b-quick-order__information__need-help">
                <h4 class="headline-xs">Need help with quick order?</h4>
                <div class="cta-wrapper">
                    <a class="instruction-link" v-if="instructionsUrl" :href="instructionsUrl" target="_blank"><span class="title-s" aria-label="See instructions"><SeeInstructionsIcon />See Instructions</span></a>
                    <!-- <span @click="openYoutubeVideo" class="title-s" aria-label="See video"><img src="@icons/see-video.svg">See Video</span>-->
                    <span v-else @click="openLiveChat({ sessionStarted: false })" class="title-s" aria-label="Chat with us"><ChatWithUs />Chat With Us</span> 
                </div>
            </div>
            <div class="b2b-quick-order__information--text">
				<p class="paragraph-details">
					If an item is out of stock, it will show an ETA in the QTY field. If it does not have an ETA, then
					the item is discontinued. The Express Ordering applications does not allow for automatic back
					ordering of an item. If you would like to place a back order, please contact Rothco directly at <a
						href="tel:18006455195" aria-label="Call Rothco">1-800-645-5195</a> or <a
						href="mailto:Info@Rothco.com" aria-label="Email Rothco">Info@Rothco.com</a> All orders larger than 500 SKU'S cannot be
					placed via our Express Ordering System, please separate your orders to keep them below this size.
				</p>
			</div>
        </div>
    </section>

    <teleport  to="body" v-if="documentReady">
        <div class="b2b-express-order__cta-sticky-bar flex-row-forced">
            <div class="summary">
                <div class="summary-text">
                    <p class="title-s">Qty</p>
                    <p class="paragraph-default">{{ currentListTotals.quantity }}</p>
                </div>
                <div class="summary-text">
                    <p class="title-s">Total</p>
                    <p class="paragraph-default">{{ canSeePricing ? ('$' + formatPrice(currentListTotals.price)) : '--' }}</p>
                </div>
            </div>
            <RothcoCta v-if="canCheckout && !isAddingItems && canPlaceOrders" class="secondary white small" aria-label="Proceed to Checkout" :href="route('checkout.express')">
                Checkout
            </RothcoCta>
            <RothcoCta v-else-if="isAddingItems && +currentListTotals.skus > 0" class="secondary white small" aria-label="Add to Cart" @click.prevent="addItemsTable?.add()">
                Add to Cart
            </RothcoCta>
        </div>
    </teleport>
</div>
</template>
<script setup lang="ts">
    import moment from "moment";
    import RothcoTable from "@/components/RothcoTable.vue";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { ref, computed, watch, onMounted, onBeforeUnmount, inject } from "vue";
    import type { PropType } from "vue";
    import { router, Link, usePage } from "@inertiajs/vue3";
    import { useRouter } from "@/helpers/composables/useRouter";
    import { useLists } from "@/helpers/composables/useList";
    import SelectDropdown from "@/components/SelectDropdown.vue";
    import QuickOrderingSearchPage from "@/components/QuickOrderingSearchPage.vue";
    import RenameListModal from "@/components/RenameListModal.vue";
    import CreateListModal from "@/components/CreateListModal.vue";
    import { useMagicKeys } from "@vueuse/core";
    import {type MomentInput} from "moment";
    import Cms from "@/components/Cms.vue";
    import { formatPrice } from "@/helpers/composables/usePriceFormatting";
    
    import { useSettingsStore } from "@/store/settings";
    import { storeToRefs } from "pinia";

    import { useDialog } from "primevue/usedialog";
    import useLiveChat from "@/helpers/composables/useLiveChat";
    import BellIcon from "@icons/bell.svg";
    import SearchIcon from "@icons/search-icon.svg";
    import SeeInstructionsIcon from "@icons/see-instructions.svg";
    import ChatWithUs from "@icons/chat-with-us.svg";
    let { setOverlayMessage } = useSettingsStore();
    
    let dialog = useDialog();
    interface ItemList {
        list_id: number;
        name?: string;
        created_at?: string;
        updated_at?: string;
        total_quantity?: number;
    }

    let props = defineProps({
        searchResults: {
            type: Object,
            default() {
                return [];
            }
        },
        searchParam: {
            type: String,
            default: ""
        },
        lists: {
            type: Array as PropType<ItemList[]>,
            default() {
                return [];
            }
        },
        current_list: {
            type: Object as PropType<ItemList>,
            default() {
                return {
                    list_id: null
                };
            }
        },
        currentListItems: {
            type: Array,
            default() {
                return [];
            }
        },
        instructionsUrl: {
            type: String,
            default: ""
        }
    }); 

    const viewListTable = ref();
    const addItemsTable = ref();
    const headerMsgs = ref([]);
    const randNum = Math.random();
    const headerMsg = computed(()=>{
        let headerMsgIndex = Math.floor((headerMsgs.value.length-1) * randNum);
        return headerMsgs.value[headerMsgIndex]?.text ?? 'You can now view & download UPC codes by clicking the UPC number for any given item'

    })

    const title = computed(() => {
        return isAddingItems.value ? `Search for "${inputValue.value}"` : "Quick Order";
    })

    let currentListTotals = ref<{price: string|number, quantity: string|number, styles: string|number, skus: string|number}>({price: 0, quantity: 0, skus: 0, styles: 0});
    let newListMap = computed(()=>{
        return lists.value?.map((list, i) => {
            list.created_at = list.created_at && typeof window !== 'undefined' ? moment(list.created_at).format("MM/DD/YYYY") : "";
            if (!list.name) {
                list.name = `Un-named Cart${list.created_at ? ` - ${list.created_at}` : ""}`;
            }
            return {
                key: list.list_id,
                value: list.name,
                record: list
            };
        }) ?? []
    });


    let lists =  computed(()=>{
        return props.lists;
    });

    let currentList = computed({
        get(){
            return newListMap.value.find((list) => list.key == props.current_list.list_id) ?? {
                key: null,
                value: "No List Selected",
                record: { list_id: null }
            };
        },  
        set(newVal){
            setCurrentList(newVal)
        }
    })

    let listsMap = computed(() => {
        return (
            props.lists?.map((list, i) => {
                if (i == 0) list = props.current_list;
                list.created_at = list.created_at && typeof window !== 'undefined' ? moment(list.created_at).format("MM/DD/YYYY") : "";
                if (!list.name) {
                    list.name = `Un-named Cart - ${list.created_at}`;
                }
                return {
                    label: list.name,
                    value: list.list_id,
                    record: list
                };
            }) ?? []
        );
    });

    const formatDisplayDate = (date: MomentInput)=>{
        return date && typeof window !== 'undefined' ? moment(date).format('MMMM D, YYYY [at] h:mm a') : "-";
    }

    const canCheckout = computed(()=>{
        return +(currentList.value?.record?.total_quantity ?? 0) > 0;
    })

    let openRenameList = function () {
        dialog.open(RenameListModal, {
            data: {
                list_name: props.current_list.name,
                list_id: props.current_list.list_id,
                beforeClose:renameListBeforeClose
            }
        })
    };
    let renameListBeforeClose = () => {
        to({ newParams: {}, options: { only: ["current_list", "lists"] } });
    };

    const listIds = new Set(lists.value.map((list) => list.list_id));

    let handleSearch = (keyword) => {
        searchLists(keyword, {
            afterFetch: (data) => {           
                appendLists(data.data);
            }
        });
    }

    const appendLists = (responseData) => {
        responseData.forEach((item) => {
            if (!listIds.has(item.list_id)) {
                listIds.add(item.list_id);
                lists.value.push(item);
            }
        });
    };

    let openCreateList = function () {
        dialog.open(CreateListModal, {
            data: {
                make_current: true,
                afterFetch: createListAfterFetch
            }
        });
    };
    let createListAfterFetch = () => {
        to({
            newParams: {},
            options: { only: ["lists", "current_list", "currentListItems"] }
        });
    };
    let route = inject("route");
    let { makeCurrentList, searchLists } = useLists({
        router,
        route
    });

    const setCurrentList = ($event) => {
        let selectedList = $event?.record;
        if(selectedList){
            makeCurrentList({list_id: selectedList.list_id}, {
                preserveScroll: true,
                onFinish: () => {
                    to({
                        newParams: {},
                        options: { only: ["current_list", "currentListItems"] }
                    });
                }
            });
        }
        
    };

    const { to } = useRouter({
        router,
        route
    });

    const isAddingItems = computed(() => {
        return usePage().url.includes('?search=');
    });

    let inputValue = ref(props.searchParam);

    let isStyle = computed(() => {
        return /^\d+$/.test(inputValue.value) && inputValue.value.length < 10;
    });

    let isUpc = computed(() => {
        return /^\d+$/.test(inputValue.value) && inputValue.value.length === 12;
    });

    let keywordSearchResults = computed(() => {
        if (props.searchResults.length > 0 && !isStyle.value && !isUpc.value) {
            return props.searchResults.map((item) => {
                return {
                    data: {
                        item_name: item.name,
                        image: item.image
                            ? `${import.meta.env.VITE_APP_URL}/upload/product/product/large/${item.image.image_filename}`
                            : null,
                        seo_name: item.seo_name,
                        primary_item_no: item.primary_item_no,
                        item_short_desc: item.item_short_desc
                            ? stripHtml(item.item_short_desc)
                            : ""
                    }
                };
            });
        }
        return [];
    });

    let visibleFields = computed(() => {
        return [
            {
                label: "",
                field: "image",
                is_custom: true
            },
            {
                label: "Item",
                field: "item_name",
                is_custom: true
            },
            {
                label: "Description",
                field: "item_short_desc",
                is_custom: true,
                pt: {
                    bodyCell: { class: 'mob-w-50' }
                }
            }
        ];
    });

    // remove html tags from string
    let stripHtml = (html) => {
        if (typeof DOMParser !== "undefined") {
            let doc = new DOMParser().parseFromString(html, "text/html");
            return doc.body.textContent || "";
        }
        return html;
    };

    let selectedRow = ref(null);

    watch(selectedRow, (newVal) => {
        if (newVal) {
            router.visit(route("index.quickOrdering"), {
                only: ["searchResults", "searchParam"],
                data: { search: selectedRow.value.data.primary_item_no }
            });
        }
    });
    let search = () => {
        if(!inputValue.value?.trim()) return;

        const searchRouteName = isStyle.value || isUpc.value 
            ? "index.quickOrdering" 
            : "index.quickOrdering.items";

        let timeout; 

        router.visit(route(searchRouteName), {
            only: ["searchResults", "searchParam"],
            preserveScroll: true, preserveState: true,
            data: { search: inputValue.value },
            onStart() {
                timeout = setTimeout(() => {
                    setOverlayMessage("This is taking longer than usual. Please wait...");
                }, 2000); 
            },
            onFinish() {
                setOverlayMessage(null);
                clearTimeout(timeout);
            },
        });
    };

    let { escape } = useMagicKeys();

    watch(escape, (newVal) => {
        if (newVal && ![null, ""].includes(props.searchParam)) {
            router.visit(route("index.quickOrdering"));
        }
    });


    let store = useSettingsStore();
    let { canSeePricing, canPlaceOrders } = storeToRefs(store);

    let currentListSelector = ref();

    
    const search_input = ref(null);

    let documentReady = ref(null);
    onMounted(()=>{
        documentReady.value = !!document.body;
        if(props.searchParam){
            inputValue.value = props.searchParam;
        }
        search_input?.value?.$el?.focus?.();
        if(typeof window !== "undefined"){
            let chaportIntegration = document.getElementsByClassName('chaport-launcher-button');
            if(chaportIntegration.length != 0){
                chaportIntegration[0].classList.add('hidden');
            }
        }
        
    })
    onBeforeUnmount(() => {
        if(typeof window !== "undefined"){
            let chaportIntegration = document.getElementsByClassName('chaport-launcher-button');
            if(chaportIntegration.length != 0){
                chaportIntegration[0].classList.remove('hidden');
            }
        }
    });
    let { openLiveChat } = useLiveChat();

    let openYoutubeVideo = function () {
        window.open('https://www.youtube.com/watch?v=NkhbqijrOQQ&ab_channel=Rothco', '_blank');
    }

    
</script>
